import Glyphs from '../../glyphs'
import FontAwesomeRating from '../raters/font-awesome/font-awesome-rating.vue'
import Vue from 'vue'

Vue.component('fa-rating', FontAwesomeRating)

export {
	Glyphs
}



// WEBPACK FOOTER //
// ./src/reg/font-awesome-rating.js